import React, { Dispatch, useCallback, useEffect, useRef, useState } from "react";
import closeIco from "../../assets/close-icon-color.png";
import { ItemTypes, PopupsListType } from "./RightSideMenu";
import {
  airQualityMap,
  AirQualitySensor,
  openMarkers,
  openWindowsAirQualityMap,
} from "../../mainLayer/airQuality/airQuality";
import SideAirQualityChart from "../../mainLayer/airQuality/SideAirQualityChart";
import { ResizeCallbackData } from "react-resizable";
import ReactDOM from "react-dom";
import Overlay from "ol/Overlay";
import { map } from "../../mainLayer/MainLayer";
import { Coordinate } from "ol/coordinate";
import AirQualityPopup from "../../mainLayer/airQuality/airQualityPopup";
import { useAirQualityContext } from "../../provider/AirQualityProvider";

type SideMenuPopupsType = {
  sensorId: string | null;
  name: string | null;
  pm10: number | null;
  pm25: number | null;
  pm100: number | null;
  co2: number | null;
  temperature: number | null;
  aqi: number | null;
  timestamp: string | null;
  setPopups: Dispatch<React.SetStateAction<PopupsListType[]>>;
  widthValue: number;
  setAirQualityRender: () => void;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  coordinatesPopup:Coordinate;
};

const SideMenuAirQualityPopup = (props: SideMenuPopupsType) => {
  const [lastUpdate, setLastUpdate] = useState<string | null>(null);
  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString();
  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);
  const [isDark, setIsDark] = useState<boolean>(false);
 const {AirQualityOpenSidebarMap,removeFromAirQualityOpenSidebarMap}=useAirQualityContext();
  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });

  //----------------resibleBox Function----------------

  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.4,
        resizableBoxheight: vh * 0.5,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.68,
        resizableBoxheight: vh * 0.8,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.2,
        resizableBoxMinheight: vh * 0.3,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const setAqiCondition = (aqiValue: number): string => {
    if (aqiValue !== null) {
      if (0 < aqiValue && aqiValue <= 50) {
        return "Good";
      } else if (50 < aqiValue && aqiValue <= 100) {
        return "Moderate";
      } else if (100 < aqiValue && aqiValue <= 150) {
        return "Unhealthy for sensitive group";
      } else if (150 < aqiValue && aqiValue <= 200) {
        return "Unhealthy";
      } else if (200 < aqiValue && aqiValue <= 300) {
        return "Very unhealthy";
      } else if (300 < aqiValue && aqiValue <= 500) {
        return "Hazardous";
      }
    }
    return "Good";
  };

  //   useEffect(() => {
  //   }, [widthMain,heightMain]);

  useEffect(() => {
    setWidthMain(props.widthValue);
  }, [props.widthValue, widthMain, heightMain]);

  const removeAirQualityById = (id: string) => {
    if (airQualityMap.has(id)) {
      airQualityMap.delete(id);
      openWindowsAirQualityMap.set(id, "close");
      props.setAirQualityRender();
    }
    openMarkers.set(id,false);
    removeOverlay(id);
    removeFromAirQualityOpenSidebarMap(id);
    if (AirQualityOpenSidebarMap.has(id)) {
      AirQualityOpenSidebarMap.delete(id);
    }
  };

    useEffect(() => {
        const entries = Array.from(AirQualityOpenSidebarMap.values());
        const lastEntryIndex = entries.length - 1;
        entries.forEach((details, index) => {
          const { coordinates, sensorId } = details;
          if (coordinates) {
              removeOverlay(sensorId!);
              if (index === lastEntryIndex) {
                  addOverlayClickItemLast(sensorId!, coordinates);
              } else {
                  addOverlayClickItem(sensorId!, coordinates);
              }
          }
        });
      }, [AirQualityOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };


  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <AirQualityPopup
              sensorId={props.sensorId!}
              name={props.name!}
              pm10={props.pm10!}
              pm25={props.pm25!}
              pm100={props.pm100!}
              co2={props.co2!}
              temperature={props.temperature!}
              aqi={props.aqi!}
              timestamp={props.timestamp!}
              addItem={props.addItem}
              id={props.sensorId!}
              onClose={handleClose}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.sensorId!, "air");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        const touchX = event.touches[0].clientX; // Get touch position
  
        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <AirQualityPopup
              sensorId={props.sensorId!}
              name={props.name!}
              pm10={props.pm10!}
              pm25={props.pm25!}
              pm100={props.pm100!}
              co2={props.co2!}
              temperature={props.temperature!}
              aqi={props.aqi!}
              timestamp={props.timestamp!}
              addItem={props.addItem}
              id={props.sensorId!}
              onClose={handleClose}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });
          overlay.setPosition(props.coordinatesPopup);
          map.addOverlay(overlay);
          props.removeItem(props.sensorId!, "air");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const handleClose = (incidentId: string) => {
    removeFromAirQualityOpenSidebarMap(incidentId);
    openWindowsAirQualityMap.set(incidentId, "close");
     if (airQualityMap.has(incidentId)) {
      airQualityMap.delete(incidentId);
            }
  };



    useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);

    // const handleClose = (incidentId: string) => {
    //   openWindowsMap.set(incidentId, "close");
    // };

  return (
    <div className={`popup`}>
      <div className={`titleWrapper`} ref={popupRef}>
        <span>{props.name}</span>
        <div className={`titleButtonContainer  no-drag`}>
          {/* <i className={`titleIcon fullScreenIco`}></i> */}
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => {
              if (props.sensorId !== null) {
                removeAirQualityById(props.sensorId);
              }
            }}
            onTouchStart={(e) => {
              if (props.sensorId !== null) {
                removeAirQualityById(props.sensorId);
              }
            }}
          ></i>
        </div>
      </div>
      <div className={`air-quality-wrapper `}>
        <div className={`chart  no-drag`}>
          <SideAirQualityChart
            id={props.sensorId!}
            name={setAqiCondition(props.aqi ?? 0)}
            aqi={props.aqi!}
            showDialog={true}
            chartWidth={widthMain > 1000 ? widthMain * 0.7 : widthMain * 0.9}
            chartHeight={300}
            setLastUpdate={setLastUpdate}
          />
        </div>
        <div className={`colors`}>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#03FE03" }}
            ></i>
            <span>good</span>
          </div>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#FFFF33" }}
            ></i>
            <span>moderate</span>
          </div>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#D4A017" }}
            ></i>
            <span>unhealthy for sensitive group</span>
          </div>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#F1594C" }}
            ></i>
            <span>unhealthy</span>
          </div>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#6C2DC7" }}
            ></i>
            <span>very unhealthy</span>
          </div>
          <div className={`legendItem`}>
            <i
              className={`colorBox`}
              style={{ backgroundColor: "#7B1515" }}
            ></i>
            <span>hazardous</span>
          </div>
        </div>
        <div className={`detailsAir`}>
          <div className={`detailItem`}>
            <span className={`label`}>date and time: </span>
            <span className={`data`}>
              {" "}
              {date}, {time}
            </span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>AQI: </span>
            <span className={`data`}>{Math.round(props.aqi ?? 0)}</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>last update: </span>
            <span className={`data`}>{lastUpdate}</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>source: </span>
            <span className={`data`}>NBRO</span>
          </div>
        </div>
        <div className={`values`}>
          <div className={`detailItem`}>
            <span className={`label`}>PM2.5: </span>
            <span className={`data`}>{props.pm25} ug/m3</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>PM10: </span>
            <span className={`data`}>{props.pm100} ug/m3</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>CO2: </span>
            <span className={`data`}>{props.co2} ppm</span>
          </div>
          <div className={`detailItem`}>
            <span className={`label`}>temperature: </span>
            <span className={`data`}>{props.temperature} °C</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenuAirQualityPopup;
